import { memo } from "react";

import { useSheetModal } from "./SheetModal";
import { SheetModalScrollView } from "./SheetModalScrollView";

import type { CSSProperties, PointerEvent, ReactNode } from "react";

export interface SheetModalBodyContainerProps {
  children?: ReactNode;
}

export const SheetModalBodyContainer = memo(function SheetModalBodyContainer({
  children,
}: SheetModalBodyContainerProps) {
  const { dragControls, disableGestures, scrollable } = useSheetModal();

  const enableGestures = !disableGestures && !scrollable;

  const style: CSSProperties = {
    touchAction: enableGestures ? "none" : undefined,
    display: scrollable ? "flex" : undefined,
  };

  function handlePointerDown(e: PointerEvent) {
    if (enableGestures) {
      dragControls?.start(e);
    }
  }

  return (
    <div
      className="SheetModalBodyContainer"
      style={style}
      onPointerDown={handlePointerDown}
    >
      {scrollable ? (
        <SheetModalScrollView>{children}</SheetModalScrollView>
      ) : (
        children
      )}
    </div>
  );
});
